import { CookiebotPreferencesLinkComponent } from "front-end/components/cookiebot/cookiebot-preferences-link.component";

export class CookiebotService {
    private _currentContext: JQuery = $();
    private _link: CookiebotPreferencesLinkComponent = null;

    private bindEvents(): void {
        this._link.on("click").subscribe(() => window.Cookiebot.renew());
        window.addEventListener("CookiebotOnConsentReady", this.reloadPage, false);
    }

    private reloadPage = (): void => {
        // This check is necessary because CookiebotOnConsentReady, CookiebotOnAccept are triggered every time on load page, not only on user submit.
        // Not null/undefined dialog means that CookiebotOnConsentReady, CookiebotOnAccept are trigered by user.
        // See more about events here: https://www.cookiebot.com/en/developer/
        if (window.Cookiebot?.dialog) {
            window.location.reload();
        }
    };

    private parseContext(): void {
        this._link = new CookiebotPreferencesLinkComponent();
        this._link.init(this._currentContext);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
